module.exports = __webpack_public_path__ + "img/saint_kitts_and_nevis.9e53a4b.webp";